import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useMemo } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ReactGA from "react-ga";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { connect } from "react-redux";
import { Router } from "react-router-dom";
import "./App.css";
import "./assets/styles.css";
import { history } from "./modules/history.js";
import { currentStudy } from "./config";
import { mapDispatchToPropsLogin, mapStateToPropsLogin } from "./modules/login";
import Routes from "./router/components/Routes";
import {
  default as routes,
  root as defaultRoute,
  onRouteChange,
  onProtectedRouteChange,
} from "./router/routes";
import { ToastType } from "./components/ToastManager/constants";
import { sendNotification } from "./components/ToastManager/ToastManager";
import { modalType, urlStudies } from "./modules/constants";

const App = (props) => {
  const { logout, token, setOpenAuthModal } = props;

  const { t } = useTranslation();

  useEffect(() => {
    //Google analytics
    if (
      process.env.REACT_APP_BRANCH &&
      (process.env.REACT_APP_BRANCH !== "development" ||
        process.env.REACT_APP_BRANCH !== "dev" ||
        process.env.REACT_APP_BRANCH !== "mt")
    ) {
      ReactGA.initialize("UA-154451573-1");
      history.listen((location, action) => {
        ReactGA.pageview(location.pathname + location.search);
      });
    }
  });

  const showIdleToast = () => {
    if (
      token &&
      currentStudy() &&
      [
        urlStudies.lcfaod402.toLocaleUpperCase(),
        urlStudies.beyondxlh402.toLocaleUpperCase(),
      ].includes(currentStudy().toLocaleUpperCase())
    ) {
      sendNotification(t("appText.warning.timeOut"), ToastType.WARNING);
    }
  };

  useIdleTimer({
    timeout: 300000,
    onIdle: showIdleToast,
    debounce: 500,
  });

  const showLogoutWarningToast = () => {
    if (
      token &&
      currentStudy() &&
      [
        urlStudies.lcfaod402.toLocaleUpperCase(),
        urlStudies.beyondxlh402.toLocaleUpperCase(),
      ].includes(currentStudy().toLocaleUpperCase())
    ) {
      sendNotification(t("appText.warning.logout"), ToastType.WARNING);
    }
  };

  useIdleTimer({
    timeout: 900000,
    onIdle: showLogoutWarningToast,
    debounce: 500,
  });

  const handleOnIdle = () => {
    //If logged
    if (token) {
      const title = t("contentText.sessionTimeOut.title");
      const message = t("contentText.sessionTimeOut.message");
      const buttonText = t("appText.auth.login");

      history.push("/home");
      setTimeout(() => {
        logout();
        setOpenAuthModal(modalType.loggedOut, title, null, message, buttonText);
      }, 1000);
    }
  };

  const timeout = useMemo(() => {
    let timer = 1200000;
    if (
      currentStudy() &&
      ![
        urlStudies.lcfaod402.toLocaleUpperCase(),
        urlStudies.beyondxlh402.toLocaleUpperCase(),
      ].includes(currentStudy().toLocaleUpperCase())
    ) {
      timer =
        process.env.REACT_APP_BRANCH &&
        ["development", "dev", "mt", "qa-mt", "training-mt"].includes(
          process.env.REACT_APP_BRANCH
        )
          ? 3.154 * Math.pow(10, 10)
          : 600000; //10min for any env, 1 year for excluded branches
    }
    return timer;
  }, []);

  useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
    debounce: 500,
  });
  return (
    <Router history={history}>
      <Routes
        routes={routes}
        default={defaultRoute}
        {...{ onRouteChange }}
        {...{ onProtectedRouteChange }}
        {...props}
      />
    </Router>
  );
};

const mapDispatchToProps = {
  logout: mapDispatchToPropsLogin.logout,
  setOpenAuthModal: mapDispatchToPropsLogin.setOpenAuthModal,
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsLogin(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
